import { useState } from 'react';
import axios from 'Axios';
import { api, toastify, clx } from 'Utils';
import { ModalBox, Button } from 'Elements';
import styles from 'partials/modalbox/modal-form.module.scss';

export const ModalBoxUploadText = ({ isOpen, onClose, size, storyId }) => {
	const [state, setState] = useState({
		fields: {
			title: '',
			body: '',
			description: ''
		},
		errors: []
	});

	const handleInput = (e) => {
		const fields = state.fields;
		const target = e.target;
		fields[target.name] = target.value;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const submitForm = () => {
		const data = {
			...state.fields,
			...{
				story_id: storyId,
				content_type: 'text'
			}
		};

		axios.post(api.storeStory, data).then((res) => {
			const data = res.data;
			if (data.success) {
				onClose?.();
				toastify(
					<>
						<p>ثبت متن با موفقیت انجام شد</p>
						<p>متن شما بعد از تایید ناظر به نمایش در میآید</p>
					</>,
					'success'
				);
			}
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		submitForm();
	};

	return (
		<ModalBox isOpen={isOpen} onClose={onClose} size={size}>
			<header className={styles.header}>
				<h3 className={styles.headerTitle}>افزودن متن</h3>
			</header>
			<div className={styles.body}>
				<form className={styles.form} onSubmit={handleSubmit}>
					<div className={styles.fieldset}>
						<label htmlFor="title" className={styles.label}>
							عنوان
						</label>
						<input
							type="text"
							id="title"
							name="title"
							placeholder="عنوان متن"
							className={styles.input}
							onChange={handleInput}
						/>
					</div>
					<div className={styles.fieldset}>
						<label htmlFor="body" className={styles.label}>
							متن
						</label>
						<textarea
							id="body"
							name="body"
							placeholder="متن کامل"
							col="20"
							rows="20"
							className={[styles.input, styles.inputLong].join(
								' '
							)}
							onChange={handleInput}
						/>
					</div>
					<div className={styles.fieldset}>
						<label htmlFor="description" className={styles.label}>
							توضیحات
						</label>
						<textarea
							id="description"
							name="description"
							placeholder="اگر متن دارای راوی یا توضیحات خاصی می باشد در این قسمت درج نمایید"
							col="20"
							rows="10"
							className={[styles.input, styles.inputShort].join(
								' '
							)}
							onChange={handleInput}
						/>
					</div>
					<div className={clx(styles.fieldset, 'mt-30')}>
						<Button
							className={clx(styles.submit, styles.submitFull)}
							type="submit">
							ثبت متن
						</Button>
					</div>
				</form>
			</div>
		</ModalBox>
	);
};
